import { accessTokenMemory, expiresAtFromLifetime } from "@/features/auth/services/accessTokenMemory";
import { type AuthStorageInfo } from "@/features/auth/types/auth.type";
import type { StorageService } from "@/shared/services/localStorage.service";
import { storageService } from "@/shared/services/localStorage.service";

// Keys under which earlier versions persisted the access token in the localStorage.
export const LEGACY_ACCESS_TOKEN_KEYS = ["accessToken", "expiresAt"] as const;

export class AuthStorageService {
  constructor(private storageService: StorageService) {}

  // The access token is kept in memory only (see accessTokenMemory): the
  // storage service only holds the device id, which is not a secret.
  getAuthToken(): AuthStorageInfo["accessToken"] | null {
    return accessTokenMemory.getAccessToken();
  }

  saveAuthToken(accessToken: AuthStorageInfo["accessToken"], expiresIn?: number): void {
    accessTokenMemory.setAccessToken(accessToken, expiresAtFromLifetime(expiresIn));
  }

  deleteAuthToken(): void {
    accessTokenMemory.clear();
  }

  // Drops the token an earlier version left in the storage, so that no token
  // stays readable there after the update.
  purgeLegacyAuthToken(): void {
    LEGACY_ACCESS_TOKEN_KEYS.forEach((key) => this.storageService.removeItem(key));
  }

  findAuthDeviceId(): AuthStorageInfo["deviceId"] | null {
    return this.storageService.getItem("deviceId");
  }

  getAuthDeviceId(): AuthStorageInfo["deviceId"] {
    let deviceId = this.storageService.getItem("deviceId");
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      this.storageService.setItem("deviceId", deviceId);
    }
    return deviceId;
  }
}

export const authStorageService = new AuthStorageService(storageService);
